import { Context } from "@nuxt/types/app";

import { MOBILE_VIEWPORT } from "@/shared/constants/ui.constant";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function isMobileView(): boolean {
    return window.matchMedia(`(max-width: ${MOBILE_VIEWPORT}px)`).matches;
  }
  return {
    isMobileView,
  };
}
